module.exports = __webpack_public_path__ + "img/icon3.fb923ab3.svg";